import Create from './Create';
import Edit from './Edit';

export default {
  name: 'prices/series',
  create: Create,
  edit: Edit,
};
